// extracted by mini-css-extract-plugin
export default {"recomcard":"login_recomcard__VlI+c","linkstyle":"login_linkstyle__p4Jfi","cardContainer":"login_cardContainer__OUfNn"};